import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=5e0c2a3d&scoped=true"
import script from "./ErrorMessage.vue?vue&type=script&lang=js"
export * from "./ErrorMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0c2a3d",
  null
  
)

export default component.exports